"use client";
import React from "react";
import { useTranslations } from "next-intl";
import { type Blog } from "@/lib/@types/api/blog";
import { Link } from "@/navigation";

interface CategoriesProps {
	clsList: Blog.BlogCl[];
	isShowcount?: boolean;
}

const Categories: React.FC<CategoriesProps> = ({ clsList, isShowcount = true }) => {
	const t = useTranslations();

	return (
		<div className="filter-category border-line mt-6 border-b pb-8 md:mt-10">
			<div className="heading6">{t("blog.Categories")}</div>
			<div className="list-cate max-h-[500px] overflow-y-auto pr-3 pt-1 max-md:max-h-[300px]">
				{clsList.map((item) => (
					<Link
						href={`/category/${item.cls_slug}`}
						key={item.cls_id}
						className={`cate-item mt-3 flex cursor-pointer items-center justify-between `}
					>
						<div className="has-line-before text-secondary2 capitalize text-gray-500 hover:text-black">
							{item.cls_name}
						</div>
						{isShowcount && <div className="text-secondary2 text-gray-600">({item.cls_related_count})</div>}
					</Link>
				))}
			</div>
		</div>
	);
};

export default Categories;
